import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DataService from '../../services/data.service';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { format } from 'date-fns';
import LoaderOverlay from '../common/loader.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
const BlockDates = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
    const [selectedEndTime, setSelectedEndTime] = useState('');
      const [selectReason, setSelectedReason] = useState('');

  const [error, setError] = useState('');
  const [blockedList, setBlockedList] = useState([]);
   const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBlockedList();
  }, []);

  const fetchBlockedList = async () => {
    setLoading(true);

    try {
      const response = await DataService.getBlockedDates();
      console.log('Blocked dates API response:', response);

      // Ensure we always set an array
      if (response.data && Array.isArray(response.data)) {
        setBlockedList(response.data);
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        // Handle nested response structure
        setBlockedList(response.data.data);
      } else {
        console.warn('Blocked dates API returned non-array data, using empty array');
        setBlockedList([]);
      }
      setLoading(false);

    } catch (err) {
      console.error('Failed to fetch blocked list:', err);
      setBlockedList([]); // Set to empty array on error
      setLoading(false);
    }
  };

  const generateTimeOptions = () => {
    const times = ['All'];
    let hour = 10;
    let minute = 0;

    while (hour < 19 || (hour === 19 && minute === 0)) {
      const hourStr = hour.toString().padStart(2, '0');
      const minuteStr = minute.toString().padStart(2, '0');
      times.push(`${hourStr}:${minuteStr}`);
      minute += 15;
      if (minute >= 60) {
        minute = 0;
        hour++;
      }
    }

    return times;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedDate || !selectedTime || !selectedEndTime || !selectReason) {
      setError(' date,time and reason are required.');
      return;
    }

    setError('');
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');

    try {
        setLoading(true);
      await DataService.blockDateTime({ date: formattedDate, startTime: selectedTime, endTime: selectedEndTime, reason: selectReason });
      toast.success(`Blocked "${selectedTime}" on ${formattedDate}`);
      setSelectedDate(null);
      setSelectedTime('');
      setSelectedReason('');
      setSelectedEndTime('');
      fetchBlockedList();

    } catch (err) {
      console.error(err);
      toast.error('Failed to block date and time.');
                setLoading(false);

    }
  };
const generateEndTimes = (start) => {
  if (!start) return [];

  // If "All" is selected, only show "All"
  if (start === "All") return ["All"];

  // Otherwise filter times greater than start
  const all = generateTimeOptions();
  return all.filter(t => t !== "All" && t > start);
};

const columns = [
  {
    name: 'Date',
    selector: row => row.date,
    sortable: true,
  },
  {
    name: 'Start Time',
    selector: row => row.time,
    sortable: true,
  },
  {
    name: 'Reason',
    selector: row => row.reason,
    sortable: true,
  },
  {
  name: 'Actions',
  cell: row => (
    <FontAwesomeIcon
      icon={faTrash}
      className="text-danger"
      style={{ cursor: 'pointer', fontSize: '14px' }}
      onClick={() => handleDelete(row.id)}
    />
  ),
  ignoreRowClick: true,
  allowOverflow: true,
}
];
const handleDelete = async (id) => {
  if (!window.confirm('Are you sure you want to delete this blocked entry?')) return;

  try {
    setLoading(true)
    const response = await DataService.deleteBlockedDate({ id });
    toast.success(response.data.message || 'Blocked date deleted');
    fetchBlockedList(); // refresh table
  } catch (err) {
    console.log(err)
    toast.error('Failed to delete blocked date');
  }
};

  return (
     <>
     <LoaderOverlay loading={loading} />

      <h4>Block Date & Time</h4>
      <form onSubmit={handleSubmit} className="mt-3">
        <div className="mb-3">
          <label className="form-label" style={{marginRight:'10px'}}>Select Date</label>
 <DatePicker
  selected={selectedDate ? new Date(selectedDate.setHours(12, 0, 0, 0)) : null}
  onChange={(date) => {
    const adjustedDate = new Date(date.setHours(12, 0, 0, 0));
    setSelectedDate(adjustedDate);
  }}
  className="form-control px-3"
  dateFormat="yyyy-MM-dd"
  minDate={new Date()}
  placeholderText="Choose a date"
/>
        </div>
<div className='row'>
  <div className='col-md-6'>
     <div className="mb-3">
          <label className="form-label">Start Time</label>
          <select
            className="form-control px-3"
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
          >
            <option value="">Start time</option>
            {generateTimeOptions().map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        </div>
    </div>
  <div className='col-md-6'>
      <div className="mb-3">
          <label className="form-label">End Time</label>
          <select
            className="form-control px-3"
            value={selectedEndTime}
            onChange={(e) => setSelectedEndTime(e.target.value)}
            disabled={!selectedTime}   // disables until start time selected
          >
            <option value="">End time</option>
            {generateEndTimes(selectedTime).map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
    </div>

    </div>
  </div>

  <div className='row'>
    <div className='col-md-6'>
      <div className="mb-3">
         <label className="form-label">Reason</label>
        <textarea className='form-control'  onChange={(e) => setSelectedReason(e.target.value)}></textarea>
      </div>
    </div>
    </div>
       

      
        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Block Date & Time
        </button>
      </form>

      {Array.isArray(blockedList) && blockedList.length > 0 && (
        <div className="mt-5">
          <h5>Blocked Dates</h5>
          <DataTable
            columns={columns}
            data={blockedList}
            pagination
            striped
            highlightOnHover
            dense
          />
        </div>
      )}
    
    </>
  );
};

export default BlockDates;
